import { render, staticRenderFns } from "./modal-settings.vue?vue&type=template&id=55662b89&"
import script from "./modal-settings.vue?vue&type=script&lang=js&"
export * from "./modal-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports